<template>
  <b-modal
    v-if="channel"
    :id="`modal-${modalID || channel.identity}`"
    centered
    size="lg"
    body-class="border-0 rounded-0"
    modal-class="channelSimpleDetailModal text-break"
    hideHeader
    hideFooter>
    <div class="channelSimpleDetailModal__wrapper">
      <div class="d-flex justify-content-end mb-2">
        <b-button
          @click.prevent="$root.$emit('bv::hide::modal', `modal-${modalID || channel.identity}`)"
          class="st_disable-none-bigger p-0 border-0 channelDetailModal__close mx-0" variant="none">
          <i class="fas fa-times" />
        </b-button>
      </div>
      <div class="channelSimpleDetailModal__body mx-auto">
        <div class="st_accent-medium-bigger st-md_accent-medium-biggest mb-4 pb-3 ml-4 mr-4 mr-md-5 text-center text-md-left">
          {{ channel.title }}
        </div>
        <div class="channelSimpleDetailModal__content px-md-4" v-html="channel.content" />
      </div>
    </div>
  </b-modal>
</template>

<script>
  export default {
    props: {
      channel: {
        type:     Object,
        required: true,
      },
      modalID: {
        type:    String,
        default: null,
      },
    },
  }
</script>

<style lang="scss">
.channelSimpleDetailModal {
  .modal-dialog {
    &.modal-lg {
      max-width: 680px;
    }
  }

  &__wrapper {
    min-height: 368px;
    max-height: 508px;
    overflow-y: auto;

    @include media-breakpoint-up(md) {
      min-height: 418px;
      max-height: 528px;
    }
  }

  &__close {
    z-index: 1;
    line-height: 21px;

    &:hover {
      color: $st_color_gray_light;
      opacity: 0.8;
    }
  }

  &__content {
    color: rgba($st_color_gray_darker, 0.8);
  }
}
</style>
